// import Link from 'next/link'
import clsx from "clsx";

const baseStyles = {
  solid:
    "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
  outline:
    "group inline-flex ring-1 items-center justify-center rounded-full py-2 px-4 text-sm focus:outline-none",
};

const variantStyles = {
  solid: {
    slate:
      "bg-slate-900 text-black hover:bg-slate-700 hover:text-black active:bg-slate-800 active:text-black focus-visible:outline-slate-900",
    blue: "bg-[#FF8800] text-black hover:text-black hover:bg-[#E67A00] active:bg-[#E67A00] active:text-black focus-visible:outline-[#FF8800]",
    white:
      "bg-[#FF8800] text-black hover:bg-[#E67A00] active:bg-[#E67A00] active:text-black focus-visible:outline-white",
  },
  outline: {
    slate:
      "ring-slate-200 text-white hover:text-white hover:ring-slate-300 active:bg-slate-100 active:text-white focus-visible:outline-[#FF8800] focus-visible:ring-slate-300",
    white:
      "ring-slate-700 text-white hover:text-white active:ring-slate-700 active:text-white focus-visible:outline-white",
  },
};

export function Button({
  variant = "solid",
  color = "white",
  // slate
  className,
  href,
  ...props
}) {
  className = clsx(
    baseStyles[variant],
    variantStyles[variant][color],
    className
  );

  return href ? (
    <a href={href}>
      <button className={className} {...props} />
    </a>
  ) : (
    <button className={className} {...props} />
  );
}
